import React from "react";
import { NavLink } from "react-router-dom";

export default function NotificationItem(props) {
  return (
    <li class="media">
      <NavLink to={`/notification/${props.serial}`}>
        <div class="media-left">
          <i class="fas fa-bell media-object bg-teal"></i>
        </div>
        <div class="media-body">
          <h6 class="media-heading"> {props.stitle}</h6>
          <p>{props.smess}</p>
          <div class="text-muted f-s-11">{props.scat}</div>
        </div>
      </NavLink>
    </li>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Notifications/NotificationItem.js